// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__JioXJ","vLegacy":"SelectSecondary_vLegacy__2D6Z6","error":"SelectSecondary_error__1dcZX","disabled":"SelectSecondary_disabled__2o_mi"};